<template lang="pug">
  .bans
    .page-header
      h2 Public Ban List

    h3 Bans

    table(cellspacing="0", cellpadding="0")
      tr
        th ID
        th Client&nbsp;
          span.mobile-hide(@click="updateFilter('client', 'ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('client', 'DESC')").filter.desc #[menu-down-icon]
        th.mobile-hide Type
        th.mobile-hide Added&nbsp;
          span(@click="updateFilter('time_add', 'ASC')").filter.asc #[menu-up-icon]
          span(@click="updateFilter('time_add', 'DESC')").filter.desc #[menu-down-icon]
        th.mobile-hide Duration
        th.mobile-hide Expires&nbsp;
          span(@click="updateFilter('time_expire', 'ASC')").filter.asc #[menu-up-icon]
          span(@click="updateFilter('time_expire', 'DESC')").filter.desc #[menu-down-icon]
        th Reason

      tr(v-for="ban of bans")
        td {{ ban.id }}
        td
          router-link(:to="{ name: 'client', params: { id: ban.client_id } }") {{ ban.client }}
        td.mobile-hide {{ ban.type }}
        td.mobile-hide {{ ban.time_add | unixDate }}
        td.mobile-hide #[span(v-if="ban.duration > 0") {{ ban.duration }}]
        td.mobile-hide #[span(v-if="ban.time_expire >= 0") {{ ban.time_expire }}]#[span(v-else="ban.time_expire < 0", style="color: #c13d3d;") Permanent]
        td {{ ban.reason }}

    pagination(:page="$route.params.page", :pages="pages", uri="/bans/")
</template>

<script>
import BansService from '@/services/Bans';
import Pagination from '@/components/core/Pagination.vue';

import MenuUpIcon from 'vue-material-design-icons/MenuUp.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';

export default {
  name: 'bans',
  components: {
    Pagination,
    MenuUpIcon,
    MenuDownIcon,
  },
  data() {
    return {
      bans: [],
      pages: 1,
      filter: 'time_add',
      order: 'DESC',
    };
  },
  methods: {
    async update() {
      if (!this.$route.params.page) {
        this.$route.params.page = 1;
      }

      const response = await BansService.getBans(this.$route.params.page, this.filter, this.order);
      if (response.error) {
        console.log(response.error);
      } else {
        this.bans = response.data.bans;
        this.pages = response.data.pages;
      }
    },
    updateFilter(filter, order) {
      // Only update if the filter has actually changed (prevent spamming the backend for no reason)
      if (this.filter !== filter || this.order !== order) {
        this.filter = filter;
        this.order = order;
        this.update();
      }
    },
  },
  created() {
    this.update();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>
